module.exports = __webpack_public_path__ + "static/media/confetti_modal.2cd1ac62.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dashboard/confetti_modal.svg
// module id = 951
// module chunks = 71